import React from "react";
import JobBoardItem from "../JobBoardItem";

export default function InvoiceReadyOrders({
  selectedLocation,
  searchText,
  productTypesData,
  refreshStatusList,
  setRefreshStatusList,
  dateFrom,
  dateTo,
}) {
  /* ******************** All States ************************* */
  const API_CALL = "/job-board/invoice-ready-orders";
  /* ******************** All Functions ************************* */

  /* ******************** All UseEffects ************************* */

  return (
    <div>
      <div
        className="d-flex flex-wrap scrollbar-hidee gap-2 align-items-top mt-5 justify-content-between overflow-auto "
        style={{ height: "89vh" }}
      >
        {productTypesData &&
          productTypesData?.map((item) => (
            <div
              key={item?.id}
              className="bg-white flex-grow-1 overflow-hidden pb-1 custom-shadow-sm custom-border-radius "
              style={{ width: "45%", position: "relative" }}
            >
              <JobBoardItem
                API_CALL={API_CALL}
                disableInvoiceReady={false}
                filterText={searchText}
                productType={item}
                selectedLocation={selectedLocation}
                refreshStatusList={refreshStatusList}
                setRefreshStatusList={setRefreshStatusList}
                dateFrom={dateFrom}
                dateTo={dateTo}
              />
            </div>
          ))}
      </div>
    </div>
  );
}
